import { render, staticRenderFns } from "./HelpChance.vue?vue&type=template&id=07f876c8&scoped=true&"
import script from "./HelpChance.vue?vue&type=script&lang=js&"
export * from "./HelpChance.vue?vue&type=script&lang=js&"
import style0 from "./HelpChance.vue?vue&type=style&index=0&id=07f876c8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f876c8",
  null
  
)

export default component.exports